import { z } from 'zod';
import { optionalUuidArray, optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
export const updateUserInputSchema = z.object({
    departmentId: optionalUuidString('Invalid department selection.').optional().nullable(),
    // Nullable to match UpdateUserInputValue.roleIds' GraphQL-nullable-list type -- the resolver
    // already treats an explicit null the same as omitted (see update-user.ts), so this schema
    // must actually let null through rather than rejecting it before the resolver sees it.
    roleIds: optionalUuidArray('Invalid role id.', {
        maxItems: 200,
        tooManyMessage: 'Too many role ids.',
    })
        .optional()
        .nullable(),
    // Same nullable-list reasoning as roleIds above.
    locationGroupIds: optionalUuidArray('Invalid location group id.', {
        maxItems: 500,
        tooManyMessage: 'Too many location group ids.',
    })
        .optional()
        .nullable(),
    // Same nullable-list reasoning as roleIds above.
    brandIds: optionalUuidArray('Invalid brand id.', {
        maxItems: 500,
        tooManyMessage: 'Too many brand ids.',
    })
        .optional()
        .nullable(),
    // Same nullable-list reasoning as roleIds above, plus a cap since StateConst is bounded (US states + territories).
    stateIds: z
        .array(requiredUuidString('State id is required.', 'Invalid state id.'))
        .max(60, 'Too many state ids.')
        .optional()
        .nullable(),
    defaultLocationGroupId: optionalUuidString('Invalid location group selection.')
        .optional()
        .nullable(),
    allBrands: z.boolean().optional().nullable(),
    allStates: z.boolean().optional().nullable(),
    allLocationGroups: z.boolean().optional().nullable(),
});
//# sourceMappingURL=update-input.js.map